import axios from 'axios';
import { Category } from '../models/Category';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://default-api.com';

/** In a branch, the API applies that branch's prices, sold-out and hidden items. */
export const fetchCategories = async (lang: 'en' | 'gr', branch?: string | null): Promise<Category[]> => {
  try {
    const branchParam = branch ? `&branch=${encodeURIComponent(branch)}` : '';
    const response = await axios.get<Category[]>(`${API_BASE_URL}/categories?lang=${lang}${branchParam}`);

    // Transform categories: merge subcategories' items into main items array
    const transformedCategories = response.data.map((category) => {
      const allItems = [
        ...(category.items ?? []), // Keep existing items
        ...(category.subcategories?.flatMap((sub) => sub.items) ?? []) // Merge subcategory items
      ];

      return {
        ...category,
        items: allItems, // Set merged items
        subcategories: category.subcategories ?? [], // Preserve subcategories
      };
    });

    return transformedCategories;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw new Error('Failed to fetch categories');
  }
};
